export default "__VITE_ASSET__BesC7jQ0__"